import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { onAddCompanyOverview } from '../../features/appSlice';

const CompanyOverview = (props) => {
    const state = useSelector(state => state);
    const dispatch = useDispatch();
    const handleCompanyOverview = (e) => {
        dispatch(onAddCompanyOverview(e.target.value));
    }

    return (
        <div className={`tab-pane fade ${(props.activeTab === 2) && 'show active'}`} id="companyinfo" role="tabpanel" aria-labelledby="companyinfo-tab">
            <div className='col-md-12'>
                <div className='form-group'>
                    <label className='fw-bold'>Company Overview</label>
                    <textarea
                        className='form-control'
                        name='dataoverview'
                        id="test"
                        value={state.app.contextData.company_overview ? state.app.contextData.company_overview : ''}
                        rows={8}
                        onChange={handleCompanyOverview}
                    >
                        {/* {props?.dataUrl || props?.dataUrls} */}
                    </textarea>
                </div>
            </div>
        </div>
    )
}

export default CompanyOverview